import type { Product } from '@/types/product';

/**
 * Ticket parent/child classification (backend `Product.ticketCategory`):
 *   - 'main'       → parent: a park-entry ticket, sold standalone.
 *   - 'attraction' → child: attached to a main ticket as an add-on (per visitor).
 * The BE rejects a cart with no main ticket, so attractions are never sold alone.
 */
export const isMainTicket = (p: Product): boolean =>
  (p.ticketCategory ?? '').toLowerCase() === 'main';

export const isAttraction = (p: Product): boolean =>
  (p.ticketCategory ?? '').toLowerCase() === 'attraction';
